import { cn } from '@/lib/utils';
import Card from '../ui/Card';
import React from 'react';
import { useTheme } from "@mui/material/styles";

interface NavigationCardProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    title: string;
    description: string;
    icon: React.ReactNode;
    onClick: () => void;
}

const NavigationCard = ({
    children,
    className,
    ...props
}: NavigationCardProps) => {
    const theme = useTheme();

    return (
        <Card className={cn("w-72", "h-52", "border-border-default", className)}>
            <div
                className={cn(
                    "flex flex-col items-center justify-center p-4 cursor-pointer ",
                    className,
                )}
                {...props}
            >
                <div className="mb-2 rounded-full p-2" style={{ backgroundColor: theme.palette.background.dark }}> {
                    React.cloneElement(props.icon as React.ReactElement, {
                        className: "size-10",
                    })
                }</div>
                <span className="text-lg font-semibold">{props.title}</span>
                <span className="text-sm text-gray-500 mt-1 text-center">
                    {props.description}
                </span>
            </div>
            {children}
        </Card>
    );
};

export default NavigationCard;